import {
  ObservationRefFragment,
  ObservationsQuery,
  useObservationsSuspenseQuery,
  withStandardListSuspenseHook,
} from '@spotify/confidence-graphql';

export const useObservationsSuspense = withStandardListSuspenseHook<
  ObservationsQuery,
  ObservationRefFragment,
  'observations'
>(useObservationsSuspenseQuery, 'observations');
